import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getRentalBookingsList = (bookingData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_RENTAL_BOOKINGS_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/rental-booking/list`,
        bookingData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_BOOKINGS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RENTAL_BOOKINGS_LIST_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_BOOKINGS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getRentalBookingView = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RENTAL_BOOKING_VIEW_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/rental-booking/view/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_BOOKING_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RENTAL_BOOKING_VIEW_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_BOOKING_VIEW_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getRentalPaymentHistoryList = (paymentData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/rental-booking/payment-list`,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_LIST_FAILED", payload: data });
      } 
      return data;
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_PAYMENT_HISTORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getRentalPaymentHistoryView = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_VIEW_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/rental-booking/payment-view/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RENTAL_PAYMENT_HISTORY_VIEW_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_PAYMENT_HISTORY_VIEW_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listRequestPayments = (paymentsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RENTAL_PAYMENTS_REQUEST_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/rental-booking/request-refund-list`,paymentsData,config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_RENTAL_PAYMENTS_REQUEST_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RENTAL_PAYMENTS_REQUEST_LIST_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_RENTAL_PAYMENTS_REQUEST_LIST__FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateStatus = (id, statusData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RENTAL_STATUS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(`${BASE_URL}/rental-booking/update-status/${id}`, statusData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RENTAL_STATUS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_RENTAL_STATUS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RENTAL_STATUS_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};